import React from "react";
import { Link } from "react-router-dom";

import Config from "../Config/sizes.json";
import Bits from "../Data/usa-sku.json";

import { MainContext } from "../App";
import { Title, GreyButton } from "../Styles/grid";

const checker = ({ bit, usage, stage }) => {
  // Main arrays
  let standard = [];
  let impact = [];

  let sSize = [];
  let iSize = [];

  // Load sizes from Config{
  Config[0].Sizes.map((aaa, i) => {
    standard[i] = aaa.number;
    return false;
  });
  Config[1].Sizes.map((aaa, i) => {
    impact[i] = aaa.number;
    return false;
  });

  //Check if there are any standard Bits
  let sskus = [];
  let iskus = [];

  for (const l in standard) {
    sskus[l] = Bits.find(bitt => bitt.sku.endsWith(`${bit}_${standard[l]}`));
  }

  for (const l in impact) {
    iskus[l] = Bits.find(bitt => bitt.sku.endsWith(`${bit}_${impact[l]}`));
  }

  // Refine selection and return to main arrays
  if (sskus.length > 0) {
    let group = [];
    for (const n in sskus) {
      if (sskus[n] !== undefined) {
        group[n] = `${sskus[n].sku}`;
      }
    }
    for (const k in group) {
      const tmp = group[k].split("_");
      sSize[k] = tmp[3];
    }
  }

  if (iskus.length > 0) {
    let group = [];
    for (const n in iskus) {
      if (iskus[n] !== undefined) {
        group[n] = `${iskus[n].sku}`;
      }
    }
    for (const k in group) {
      const tmp = group[k].split("_");
      iSize[k] = tmp[3];
    }
  }
  //Cheesing it
  if (bit === false) {
    sSize = ["25", "50"];
  }
  if (bit === false) {
    iSize = ["29", "49"];
  }

  // return for usage buttons
  if (bit !== undefined && stage === "usage") {
    let stemp = null;
    let itemp = null;

    if (sSize.length > 0 || bit === "false") {
      stemp = "standard";
    }

    if (iSize.length > 0 || bit === "false") {
      itemp = "impact";
    }

    return Config.map(aaa => {
      if (aaa.Type === `${stemp}`) {
        return (
          <MainContext.Consumer key={aaa.Type}>
            {context => (
              <Link
                to={`${aaa.Type}/`}
                onClick={type => context.usageSet(`${aaa.Type}`)}
              >
                <button>
                  <Title>{aaa.Type}</Title>
                </button>
              </Link>
            )}
          </MainContext.Consumer>
        );
      }
      if (aaa.Type === `${itemp}`) {
        return (
          <MainContext.Consumer key={aaa.Type}>
            {context => (
              <Link
                to={`${aaa.Type}/`}
                key={aaa.Type}
                onClick={type => context.usageSet(`${aaa.Type}`)}
              >
                <button>
                  <Title>{aaa.Type}</Title>
                </button>
              </Link>
            )}
          </MainContext.Consumer>
        );
      } else {
        return (
          <GreyButton key={aaa.Type} disabled>
            <Title>{aaa.Type}</Title>
          </GreyButton>
        );
      }
    });
  }
  // return for length buttons
  if (bit !== undefined && usage !== undefined && stage === "length") {
    return Object.values(
      Config.find(type => type.Type === `${usage}`).Sizes
    ).map((items, i) => {
      if (items.number === sSize[i]) {
        return (
          <MainContext.Consumer key={items.Type}>
            {context => (
              <Link
                to={`${items.bitLength}/`}
                onClick={size => context.setLeng(items.bitLength)}
              >
                <button>
                  <Title>{items.bitLabel}</Title>
                </button>
              </Link>
            )}
          </MainContext.Consumer>
        );
      }
      if (items.number === iSize[i]) {
        return (
          <MainContext.Consumer key={items.Type}>
            {context => (
              <Link
                to={`${items.bitLength}/`}
                onClick={size => context.setLeng(items.bitLength)}
              >
                <button>
                  <Title>{items.bitLabel}</Title>
                </button>
              </Link>
            )}
          </MainContext.Consumer>
        );
      } else {
        return (
          <GreyButton key={items.Type} disabled>
            <Title>{items.bitLabel}</Title>
          </GreyButton>
        );
      }
    });
  } else {
    return <p>Error Code: 201</p>;
  }
};

export default checker;
